module.exports = __webpack_public_path__ + "a9cbc6e400cd961706ef5e528563fe6d.png";